import SectionTitle from '../../../components/SectionTitle/SectionTitle'
import './CourseRequirements.css'

export default function CourseRequirements({text, isGrand = false}) {
   return (
      <div className={`course-requirements-container ${isGrand ? "course-requirements-container_grand" : ""}`}>
         <SectionTitle upText='requisitos' downText='Para quien es este curso' isGrand={isGrand} />
         <p className='course-requirements-description'>
             {text}
         </p>
      </div>
   )
}
